import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Params, Router } from '@angular/router';
import { User } from '../../models/user.model';
import { TokenStorageService } from '../../services/token-storage.service';
import { UserService } from '../../services/user.service';
import Swal from 'sweetalert2';
import { FormBuilder, FormGroup } from '@angular/forms';
@Component({
  selector: 'app-view-user',
  templateUrl: './view-user.component.html',
  styleUrls: ['./view-user.component.scss']
})
export class ViewUserComponent implements OnInit {

  public user: User;
  public errormsg:string;
  public loading: boolean;
  
  currentUser: any;
  contactform: FormGroup;
  constructor(
    private formBuilder: FormBuilder,
              private router: Router,
              private route: ActivatedRoute,
              private usersservice: UserService,
              private token: TokenStorageService,
             ) { }
  ngOnInit() {
    this.loading = true;
    this.currentUser = this.token.getUser();
  
    this.route.params.subscribe(
      (params: Params) => {
        this.usersservice.getUserById(params.id).then(
          (user: User) => {
            this.loading = false;
            this.user = user;
            this.contactform = this.formBuilder.group({
              email: ['technique@finserv.tn'],
              emailenvoyea: [this.user.email,],
              description: ['',],
            });   
          }
        );
      }
    );
  
  }

  onDelete() {
    this.loading = true;
    this.route.params.subscribe(
      (params: Params) => {
        this.usersservice.getUserById(params.id).then(
          (data:any) => {
            this.loading = false;
            Swal.fire({
              title: 'Veuillez confirmer la suppression!',
              
              icon: 'info',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Confirmer',
              
            }).then((result) => {
              if (result.value) {
                this.usersservice.deleteUserById(params.id);
                this.router.navigate(['admin-board']);
              }
  
            }).catch(() => {
              Swal.fire('opération non aboutie!');
            });
    
        
          }
          
        );
      }
    );
  }

  resetpassword() {
    Swal.fire({
      title: 'Réinitialiser Mot de passe',
      input: 'password',
      inputLabel: 'Nouveau Mot de passe',
      inputPlaceholder: 'Entrez votre nouveau mot de passe',
      showCancelButton: true,
      confirmButtonText: 'Réinitialiser',
      cancelButtonText: 'Annuler',
      preConfirm: (newPassword) => {
        if (!newPassword) {
          Swal.showValidationMessage('Le mot de passe est requis');
        }  else {
          return newPassword;
        }
      }
    }).then((result) => {
      if (result.isConfirmed) {
        const newPassword = result.value;
        // Call your service to update the password
        this.updatePassword(newPassword);
        Swal.fire('Succès', 'Le mot de passe a été réinitialisé avec succès', 'success');
      }
    });
  }

  updatePassword(newPassword: string) {
    const user =this.user
    user.password =newPassword;
    user.confirmpassword =newPassword;
    this.usersservice.modifyUserById(this.user._id, user).then(  
      () => {
        this.loading = false;
        window.scrollTo(0, 0);
      },
      (error) => {
        this.loading = false
        
      }
    );
  }
  reloadPage(): void {
    setTimeout(() => window.location.reload(), 1000);    
  }
  }
